import { AxiosInstance, AxiosResponse } from 'axios'
import _ from 'lodash'

import { LocaleMap } from '../redux/config'
import { createRequestParams } from '../utils/api'

import { useApiData } from './useApiData'

export type UmbracoProductDataResponse = {
  bifCode: string
  childProductBifCode: string
  alert: string
  additionalInfo: string

  name: string
  previewDescription: string
  sampleUrl: string
  productDetailLinkLabel: string
  downloadSampleLabel: string
}

export type UmbracoProduct = {
  bifCode: string
  childProductBifCode: string
  alert: string
  additionalInfo: string

  name: string
  previewDescription: string
  sampleUrl: string
  productDetailLinkLabel: string
  downloadSampleLabel: string
}

export function mapUmbracoProductDataResponse(p: UmbracoProductDataResponse): UmbracoProduct {
  return {
    bifCode: p.bifCode,
    childProductBifCode: p.childProductBifCode,
    alert: p.alert,
    additionalInfo: p.additionalInfo,
    name: p.name,
    previewDescription: p.previewDescription,
    sampleUrl: p.sampleUrl,
    productDetailLinkLabel: p.productDetailLinkLabel,
    downloadSampleLabel: p.downloadSampleLabel
  }
}

export function useUmbracoProducts(productCodes: string[] = [], skip = false) {
  const { data, loading } = useApiData<{ data: UmbracoProductDataResponse[] }>(
    {
      url: '/api/products/products',
      method: 'post',
      data: { productCodes }
    },
    {
      umbracoCall: true,
      skip: skip
    }
  )

  return {
    loading,
    data: _.map(data?.data, p => mapUmbracoProductDataResponse(p))
  }
}

export async function loadUmbracoProducts(axios: AxiosInstance, productCodes: string[], localeMap: LocaleMap) {
  const requestConfig = createRequestParams({}, localeMap, {
    umbracoCall: true
  })

  const productsResponse: AxiosResponse<{ data: UmbracoProductDataResponse[] }> = await axios({
    url: '/api/products/products',
    method: 'post',
    data: { productCodes },
    ...requestConfig
  })

  return productsResponse.data.data
}
